import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchInvestmentTechnicalSignals } from '@apis/investmentIndicators';
import type { InvestmentTechnicalSignalsApiData } from '@app-types/investmentIndicatorsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

export const useInvestmentTechnicalSignals = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<InvestmentTechnicalSignalsApiData>({
    queryKey: ['indicators', 'technical-signals', ticker, mkt],
    queryFn: () => fetchInvestmentTechnicalSignals({
      ticker: ticker as string,
      mkt: mkt as string,
    }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};

